<div class="w-100" [ngClass]="builtClasses" role="alert">
  <ng-content></ng-content>
</div>
